const unsupportedNode = require('./helper').unsupportedNode;

module.exports = unsupportedNode('Transactions not supported by execution engine','bpmn:Transaction');
